
/**
 * 画像ファイルアップローダー
 */

$(function()
{
	/**
	 * 選択画面
	 */
	$('.img-uploader.img-uploader-editor input[type=file]').on('change', function(e){
		const $input     = $(this)
		const $container = $(this).parents('.img-uploader').eq(0)
		const $a         = $container.find('.uploading a.preview')
		const $img       = $a.find('img')
		const reader     = new FileReader()
		reader.onload    = function (e)
		{
			// ローディング状態
			if(2!==e.target.readyState) {
				alert('正しくないファイルです')
				return
			}

			// 大きめのファイルの場合はローディング画面を出す
			if(e.target.result.length > 1000000) $('body').addClass('loading')

			// 画像処理実行
			try {
				ImgB64Resize(e.target.result, $input.data('max-width'), $input.data('max-height'),
					function(img_b64) {
						$a.attr('href', img_b64)
						$img.attr('src', img_b64)
						$container.find('[type=hidden][name$=_base64]').val(img_b64)
						$container.attr('data-mode', 'uploading')
						$('body').removeClass('loading')
					}
				);
			} catch(e) {
				$('body').removeClass('loading')
			}
		}
		if(e.target.files.length) {
			reader.readAsDataURL(e.target.files[0]);
		} else {
			$container.find('.cancel').trigger('click')
		}
	})

	/**
	 * 選択画面：取り消しボタン
	 */
	$('.img-uploader.img-uploader-editor .cancel').on('click', function(e){
		const $container = $(this).parents('.img-uploader').eq(0)
		const $input     = $container.find('input[type=file]')
		const $base64    = $container.find('input[name$=_base64]')
		$input.prop('value', null)
		$base64.prop('value', null)
		$container.attr('data-mode', $container.find('.uploaded').length ? 'uploaded' : '')
		$container.parents('td').eq(0).find('[data-validon-errorholder]').remove()
	})

	/**
	 * 選択画面：削除ボタン
	 */
	$('.img-uploader.img-uploader-editor .delete').on('change', function(e){
		const $container = $(this).parents('.img-uploader').eq(0)
		$container.toggleClass('delete', $(this).val())
	})

	/**
	 * 確認画面：img[src]やa[href]をinputの値からもってくる（転送量削減のため）
	 */
	$('[data-src-from]').each(function(){
		const $img = $(this);
		$img.attr('src', $('input[name='+$img.data('src-from')+']').val())
	})
	$('[data-href-from]').each(function(){
		const $img = $(this);
		$img.attr('href', $('input[name='+$img.data('href-from')+']').val())
	})
});

// JS上で Base64 データをリサイズ
// ref: http://jsfiddle.net/9hnpdd5p/6/
function ImgB64Resize(imgB64_src, width, height, callback)
{
	// Image Type
	var img_type = imgB64_src.substring(5, imgB64_src.indexOf(";"));

	// Source Image
	var img = new Image();
	img.onload = function() {

		// リサイズ指定がない、または指定範囲を超えてないなら、base64そのまま返す
		if(!width && !height) { return callback(imgB64_src) }
		if(
			(width && img.naturalWidth>width) ||
			(height && img.naturalHeight>height)
		) {;} else { return callback(imgB64_src) }

		// New size
		var new_width
		var new_height
		var aspect = img.naturalHeight / img.naturalWidth
		if(!height) {
			new_width = width
			new_height = width * aspect
		} else if(!width){
			new_width = height * aspect
			new_height = height
		} else {
			var new_aspect = new_height / new_width
			if(new_aspect<aspect) {
				new_width = width
				new_height = width * aspect
			} else {
				new_width = height * aspect
				new_height = height
			}
		}

		// New Canvas
		var canvas = document.createElement('canvas');
		canvas.width = new_width;
		canvas.height = new_height;
		var ctx = canvas.getContext('2d');

		// Blur for high quality resizing
		const oc = document.createElement('canvas');
		const octx = oc.getContext('2d');
		oc.width = img.naturalWidth
		oc.height = img.naturalHeight
		const steps = ((oc.width / canvas.width)>>1) - 1;
		octx.filter = `blur(${steps}px)`;
		octx.drawImage(img, 0, 0);

		// Draw (Resize)
		ctx.drawImage(oc, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, new_width, new_height);

		// Destination Image
		var imgB64_dst = canvas.toDataURL(img_type);
		callback(imgB64_dst);
	};

	img.src = imgB64_src;
}
